import 'css-chunksrc/client/pages/capacityPage/table/loader/row/styles.scss';export default {
  "resourceCell": "_resourceCell_kjxsh_1",
  "avatar": "_avatar_kjxsh_15",
  "identity": "_identity_kjxsh_22",
  "name": "_name_kjxsh_29",
  "profession": "_profession_kjxsh_34",
  "cell": "_cell_kjxsh_39",
  "cellBar": "_cellBar_kjxsh_49"
};